const TermsAndConditions = () => {
    return (
      <div  style={{ margin :'40px 0' }}>
        <h3>1. Acceptance of Terms</h3>
        <p>
          By creating an account or using Classence, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions, as well as our Privacy Policy.
        </p>
        <h3>2. Eligibility</h3>
        <p>
         By using our platform, you represent and warrant that you meet the requirements and have the legal authority to enter into these Terms.
        </p>
        <h3>3. Account Registration</h3>
        <p>
          You must create an account to access certain features of Classence. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
        </p>
        <h3>4. User Conduct</h3>
        <p>
          When using Classence, you agree to use the platform only for lawful purposes and in accordance with these Terms.
        </p>
      </div>
    );
  };
  
  export default TermsAndConditions;
  